let mermaidInitialized = false

export async function loadMermaid() {
  const { default: mermaid } = await import('mermaid')

  if (!mermaidInitialized) {
    mermaidInitialized = true
    mermaid.initialize({
      startOnLoad: false,
      suppressErrorRendering: true,
      securityLevel: 'strict',
      theme: 'forest',
      fontFamily: '"Arial", "Helvetica", sans-serif',
      flowchart: {
        useMaxWidth: true,
      },
      sequence: {
        useMaxWidth: true,
      },
      state: {
        useMaxWidth: true,
      },
      git: {
        useMaxWidth: true,
      },
      class: {
        useMaxWidth: true,
      },
      gantt: {
        axisFormat: '%d.%m.%Y',
      },
    })
  }

  return mermaid
}
